export const MAX_API_LIMIT = 5000;

// use NODE_ENV
export const appApiNotification = '/notification';
export const appApiSystemAdmin = '/system-admin';
export const appApiCellBroadCast = '/fast-api-v2/cap';
export const appApiNotificationNoti = '/notification/notification';
export const appApiOnlineScamVoice = '/reporting/case_file_recording';
export const appApiOnlineScam = '/onlinescam/v1/online-scam/case';
export const appApiOnlineScamPoliceReport = '/onlinescam/v1/police-report';
export const appApiOnlineScamMasterData = '/onlinescam/v1/master';
export const appApiOnlineScamInvestigation = '/onlinescam/v1/investigation/';
export const appApiOnlineScamWitness = '/onlinescam/v1/witness-summons/';
export const appApiOnlineScamWitnessAttachment = '/onlinescam/v1/witness-summons/attachment/';
